import { render, staticRenderFns } from "./SMSServiceModal.vue?vue&type=template&id=f8198440&"
import script from "./SMSServiceModal.vue?vue&type=script&lang=js&"
export * from "./SMSServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports